import { CLOSE_GLOBAL_SNACKBAR, OPEN_GLOBAL_SNACKBAR } from "./types";

export function openGlobalSnackbar({ message, variant, autoHideDuration }) {
	return function (dispatch) {
		dispatch({
			type: OPEN_GLOBAL_SNACKBAR,
			payload: { message, variant, autoHideDuration },
		});
	};
}

export function closeSnackbar({ snackbarKey }) {
	return function (dispatch) {
		dispatch({
			type: CLOSE_GLOBAL_SNACKBAR,
			payload: { snackbarKey },
		});
	};
}

export function showBuildMismatch() {
	return function (dispatch) {
		dispatch({
			type: "SHOW_VERSION_MISMATCH",
			payload: { snackbarKey: "version-mismatch" },
		});
	};
}
